import React,{useRef} from 'react'
import emailjs from '@emailjs/browser';
import './Contact.css'
import { useState } from 'react';
import { themeContext } from '../../Context'
import { useContext } from 'react';
const Contact = () => {
    const theme = useContext(themeContext)
    const darkMode = theme.state.darkMode
    const form = useRef();

    const [done,setDone]=useState(false)

    const sendEmail = (e) => {
      e.preventDefault();
  
      emailjs.sendForm('service_wc24faw', 'template_9ff34or', form.current, 'mmIb2X1IddEU4BgqJ')
        .then((result) => {
            console.log(result.text);
            setDone(true)
        }, (error) => {
            console.log(error.text);
        });
    };
  
  return (
    <div className='contact-form'>
        <div className='w-left'>
            <div className='span'>
                <span style={{color: darkMode? 'white':' '}}>Get in touch</span>
                <span>Contact me</span>
                <div className="blur s-blur1" style={{background:'#ABF1FF94'}}
                ></div>
            </div>
        </div>
        <div className="c-right">
            <form ref={form} onSubmit={sendEmail}>
                <input type="text" name="user_name" className='user' placeholder='Name' />
                <input type="email" name="user_email" className='user' placeholder='Email' />
                <textarea name="message" className='user' placeholder='Message'></textarea>
                <input type="submit" value="Send" className="button" />
                <span>{done && "Thanks for  contacting me"}</span>
                <div className="blur c-blur1" style={{ background: "var(--purple)" }}></div>
            </form>
        </div>
    </div>
  )
}

export default Contact